import styled from 'styled-components';

import { MAX_WIDTH } from '../../../constants';
import {
  HorizontalCenterBlock,
  SpaceBetweenBlock,
  VerticalHorizontalCenterBlock
} from '../../../styled';

export const ModalContentBox = styled.div`
  margin-bottom: 24px;
`;

export const ModalContentBoxToken = styled.div`
  margin-top: 24px;
  margin-bottom: 24px;
`;

export const CommonFont = styled.span`
  font-weight: 400;
`;

export const SuccessModalWrapper = styled.div`
  padding-top: 32px;
  margin-bottom: 32px;
  text-align: center;
`;
export const InputTitle = styled.p`
  ${(props) => props.theme.typography.description}
  color: ${(props) => props.theme.colors.muted};
  margin: 0;
`;

export const DeleteClientSubtitle = styled.p`
  ${(props) => props.theme.typography.description};
  margin-bottom: 8px;
`;

export const SubHeader = styled.h3`
  ${(props) => props.theme.typography.subHeader2}
  margin-bottom: 26px;
`;

export const Header = styled.h2`
  ${(props) => props.theme.typography.accent}
  font-weight: 700;
`;

export const LinkButton = styled(SpaceBetweenBlock)`
  ${(props) => props.theme.typography.subHeader3}
  color: ${(props) => props.theme.colors.brand};
  margin-bottom: 66px;
  a {
    color: ${(props) => props.theme.colors.brand};
  }
`;

export const ModalHeaderWrapper = styled(SpaceBetweenBlock)`
  margin-bottom: 24px;
`;

export const RemoveButtonBlock = styled.div`
  margin-bottom: 24px;
  margin-top: 0px;
`;

export const RemoveButtonSubtitle = styled.div`
  ${(props) => props.theme.typography.label};
  color: ${(props) => props.theme.colors.muted};
  text-transform: none;
`;

export const TokenExtra = styled.p`
  margin-right: 40px;
`;

export const SignatureMethodChangeWrapper = styled(VerticalHorizontalCenterBlock)`
  width: 100%;
`;

export const Wrapper = styled(HorizontalCenterBlock)`
  flex-direction: column;
  width: ${MAX_WIDTH};
`;
